"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scampitella": {
    "59eec6ca": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "skipSearch": false
    }],
    "ciccarella": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "689d1819": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "skipSearch": false
    }],
    "intrisciolo": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "126b68a8": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "skipSearch": false
    }],
    "lavanga": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a850cfb3": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "skipSearch": false
    }],
    "petruzzo": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4824127f": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-piano-di-contra": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d847e44c": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "skipSearch": false
    }],
    "serra-delle-nespole": [{
      "hkey": "81122b11",
      "slug": "scampitella",
      "name": "Scampitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;